import React from "react";
import { useSelector } from "react-redux";

import Collapse from "@material-ui/core/Collapse";
import TextField from "@material-ui/core/TextField";

import {
  InputGroup,
  PanelSection,
  PanelContent,
  PanelDescription,
  PrimaryBtn,
} from "../../Theme";
import BoxTip from "../../Components/BoxTip";
import DeliveryTime from "./DeliveryTime";
import { Container } from "./styles";
import DeliveryTaxOptions from "./DeliveryTaxOptions/index";
import DeliveryFixed from "./DeliveryFixed";
import DeliveryByNeighborhood from "./DeliveryByNeighborhood/index";
import DeliveryType from "./DeliveryType";
import BasicConfig from "./BasicConfig";
import Payments from "./Payments";

export default function ConfigAttendance() {
  const {
    isLoading,
    deliveryEnabled,
    deliveryCalcMethod,
    deliveryFee,
    ...store
  } = useSelector((state) => state.store);

  function handleDeliveryCalcMethodChange(event) {}

  if (!store) return null;

  return (
    <Container>
      <PanelSection>
        <PanelDescription>
          Configurações básicas de atendimento
          <BoxTip>
            <i>
              Para criar um link para o seu cardápio separe as palavras por
              hífem (-). Exemplo: "lancheria-do-joao".
            </i>
          </BoxTip>
        </PanelDescription>
        <PanelContent>
          <BasicConfig />
        </PanelContent>
      </PanelSection>

      <PanelSection>
        <PanelDescription>
          Formas de pagamento
          {/* <BoxTip>
            <i>
              Para criar um link para o seu cardápio separe as palavras por
              hífem (-). Exemplo: "lancheria-do-joao".
            </i>
          </BoxTip> */}
        </PanelDescription>
        <PanelContent>
          <Payments />
        </PanelContent>
      </PanelSection>

      <PanelSection>
        <PanelDescription>Tipo de entrega</PanelDescription>
        <PanelContent>
          <DeliveryType />
        </PanelContent>
      </PanelSection>

      <Collapse timeout={1000} in={deliveryEnabled}>
        <PanelSection>
          <PanelDescription>Tempo de entrega</PanelDescription>
          <PanelContent>
            <DeliveryTime />
          </PanelContent>
        </PanelSection>
        <PanelSection style={{ marginTop: "20px" }}>
          <PanelDescription>
            Taxa de entrega
            <BoxTip>
              <p>
                <i>
                  Você pode copiar e colar uma lista de bairros de uma planilha
                  do Excel ou Google Sheets. Insira um novo campo (+) e cole a
                  lista dentro dele.
                </i>{" "}
              </p>
              <p>
                <i>
                  Ao salvar a lista automaticamente será reordenada em{" "}
                  <strong>ordem alfabética.</strong>{" "}
                </i>{" "}
              </p>
            </BoxTip>
          </PanelDescription>
          <PanelContent>
            <DeliveryTaxOptions onChange={handleDeliveryCalcMethodChange} />
            {!(deliveryCalcMethod === "fixed" && deliveryFee === 0) && <hr />}
            {deliveryCalcMethod === "fixed" && deliveryFee > 0 && (
              <DeliveryFixed />
            )}
            {deliveryCalcMethod === "by-neighborhood" && (
              <DeliveryByNeighborhood />
            )}
          </PanelContent>
        </PanelSection>
      </Collapse>

      {/* <PanelSection>
        <PanelDescription>Horário de Atendimento</PanelDescription>
        <PanelContent>
          <Form onSubmit={handleSubmit}>
            <InputGroup>
              <label htmlFor='delivery-fee'>Taxa fixa</label>
              <input
                value={store.deliveryFee}
                onChange={handleInputChange}
                id='delivery-fee'
                type='number'
                name='deliveryFee'
              />
            </InputGroup>

            <PrimaryBtn type='submit'>Salvar</PrimaryBtn>
          </Form>
        </PanelContent> 
      </PanelSection>*/}
    </Container>
  );
}
